// eslint-disable-next-line import/prefer-default-export
export const IRREGULAR_ICON_SIZE = 20;
